import { DialogType } from '../../@types';
import { BettingActivity, WalletType } from '../../@types/api';
import { BETTING_ACTIVITY_OPTIONS, SPORTSBOOK_FROM_OPTIONS, SPORTSBOOK_WALLET_TYPE } from '../../constants';
import { BETTING_ACTIVITY } from '../../constants/enums';
import useFilterForm from '../../hooks/useFilterForm';
import { AdditionalQueryParams } from '../../hooks/usePagination';
import usePermissions from '../../hooks/usePermissions';
import FilterDialogLayout from '../layouts/FilterDialogLayout';
import FormSelect from '../molecules/FormSelect';

export type FilterAffiliatesReportData = {
  from?: string;
  walletType?: WalletType;
  bettingActivity?: BettingActivity;
};

type Props = DialogType & {
  changeQuery: (data: AdditionalQueryParams) => void;
};

const FilterAffiliateReport = ({ changeQuery, closeModal }: Props) => {
  const { isAgent, isAffiliate } = usePermissions();
  const defaultWalletType = isAffiliate ? 'main' : undefined;

  const { control, handleSubmit, handleResetFilter } = useFilterForm<FilterAffiliatesReportData>({
    defaultData: {
      from: undefined,
      walletType: defaultWalletType,
      bettingActivity: BETTING_ACTIVITY.ACTIVE,
    },
    changeQuery,
  });

  const handleClose = () => {
    closeModal?.();
  };

  return (
    <FilterDialogLayout label='reports' onSave={handleSubmit} onClose={handleClose} onReset={handleResetFilter}>
      <FormSelect name='from' control={control} label='From' options={SPORTSBOOK_FROM_OPTIONS} />
      {!isAgent && <FormSelect name='walletType' control={control} label='Bets' options={SPORTSBOOK_WALLET_TYPE} />}
      <FormSelect
        name='bettingActivity'
        control={control}
        label='Betting Activity'
        options={BETTING_ACTIVITY_OPTIONS}
      />
    </FilterDialogLayout>
  );
};

export default FilterAffiliateReport;
